import { render } from "./List.vue?vue&type=template&id=04bb22e9&scoped=true"
import script from "./List.vue?vue&type=script&lang=ts"
export * from "./List.vue?vue&type=script&lang=ts"

import "./List.vue?vue&type=style&index=0&id=04bb22e9&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-04bb22e9"

export default script